import axios from '@/libs/axios';
import { ErrorMessage } from '@/libs/Error';

export default class SlsTemplateImagemClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async getTemplateImagem(queries = {}) {
    try {
      const { data } = await this.api.get('/template-imagem', { params: queries });
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as imagens da home');
    }
  }

  async postTemplateImagem(imagemHome) {
    try {
      return await this.api.post('/template-imagem', imagemHome);
    } catch (error) {
      throw this.error.message(error, 'Erro ao salvar a template imagem');
    }
  }

  async postTemplateImagemFamiliaComercialCodMarcaUpdatedImagens(imagemHome) {
    try {
      return await this.api.post(`/template-imagem/${imagemHome.familia_comercial_id}/${imagemHome.cod_marca}/updatedImagens`, imagemHome);
    } catch (error) {
      throw this.error.message(error, 'Erro ao salvar a template imagem');
    }
  }

  async getTemplateImagemById(id) {
    try {
      const { data } = await this.api.get(`/template-imagem/${id}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar a template imagem');
    }
  }

  async putTemplateImagem(id, imagemHome) {
    try {
      return await this.api.put(`/template-imagem/${id}`, imagemHome, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    } catch (error) {
      throw this.error.message(error, 'Erro ao atualizar a template imagem');
    }
  }

  async deleteTemplateImagem(id) {
    try {
      return await this.api.delete(`/template-imagem/${id}`);
    } catch (error) {
      throw this.error.message(error, 'Erro ao excluir a template imagem');
    }
  }

  async deleteTemplateImagemSoftDelete(id) {
    try {
      return await this.api.delete(`/template-imagem/${id}/softDelete`);
    } catch (error) {
      throw this.error.message(error, 'Erro ao excluir a template imagem');
    }
  }

  async getTemplateImagemReferenciaByCodMarca(codMarca) {
    try {
      const { data } = await this.api.get(`/template-imagem/referencias/${codMarca}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar a template imagem');
    }
  }

  async getTemplateImagemConfigByMarcaFamiliaComercial(codMarca, familiaComercialId) {
    try {
      const { data } = await this.api.get(`/template-imagem/config/${familiaComercialId}/${codMarca}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar a template imagem');
    }
  }

  async uploadTemplateImagemLocal(formData) {
    try {
      const { data } = await this.api.post('/template-imagem/upload-local', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao fazer upload da imagem');
    }
  }
}
